import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LivesCountComponent } from './lives-count/lives-count.component';

@NgModule({
  declarations: [LivesCountComponent],
  exports: [LivesCountComponent],
  imports: [
    CommonModule
  ]
})
export class LivesCountModule { }
